module.exports = __webpack_public_path__ + "img/wac-logo.45521ffe.png";